export const PAGE_SIZE = 10
export const INITIAL_PAGE = 0
export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100]
